import React, { memo, useRef, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const FormantVisualizer = ({enabled, height, width, formant}) => { 
    let groupRef = useRef(undefined);
    let frequency  = formant.formantFrequencyParameter.get();
    let q = formant.formantQParameter.get();
    let gain = formant.formantGainParameter.get();
    let x = Math.sqrt(frequency / 20000) * width;
    let y = height - (gain / 4.0) * height;

    let className = "formant";
    if (formant.enabledParameter.get()) {
        className += " enabled";
    }

    let bandwidth = frequency / (0.5 * q);
    let _bandwidthPixels= (Math.sqrt(bandwidth / 20000) * width) / 2;
    let bandwidthPixels= 100 * (width / 200);
    let scale = _bandwidthPixels/bandwidthPixels;

    let x1 = bandwidthPixels-bandwidthPixels;
    let y1 = height;
    let x2 = bandwidthPixels -bandwidthPixels / 2.0;
    let y2 = -10;
    let x3 = bandwidthPixels + bandwidthPixels / 2.0;
    let y3 = -10;
    let x4 = 2 * bandwidthPixels;
    let y4 = height;
    let curve = `M ${x1} ${y1} C ${x2} ${y2}, ${x3} ${y3}, ${x4} ${y4}`

    useEffect(() => {
        if (groupRef.current) {
            let _x = x-bandwidthPixels;
            groupRef.current.setAttribute('style', `transform: translate(${_x}px, ${y}px) scale(${scale}, 1)`);
        }
    }, [x,y,scale]);


    if (!enabled || !formant.isConnectedToAnyModulator()) {
        return [];
    }

    return (
        <div ref={groupRef}>
          <Band width={width} height={height} curve={curve}/>
        </div>
    );
};

const Band = memo(
    ({curve, width, height}) =>
        <svg height={height} width={width}>
          <path d={curve} className={"bandwidth-visualizer"}/>
        </svg>
);

const mapStateToProps = (state, props) => {
  let enabled = props.formant.enabledParameter.get();
    if (!enabled) {
        return {
            enabled
        };
    }
    return {
        enabled,
        currentStep: props.sequencerEngine.trackStep,
        frequency: props.formant.formantFrequencyParameter.get(true),
        q: props.formant.formantQParameter.get(true),
        gain: props.formant.formantGainParameter.get(true),
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormantVisualizer);
